module.exports = __webpack_public_path__ + "img/part2-icon5.56cee567.png";